import React from "react";
import { Link } from "react-router-dom";
import { tesla } from "../../../assets/images";
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { setRegisterAsHost } from "../../../redux/slices/userSlice";

const HostorLesee: React.FC = () => {
  const dispatch = useDispatch();
  return (
    <div className="w-[90%] md:w-4/5 container flex flex-col mx-auto bg-lightGreen border rounded-[10px] h-[250px] md:h-[435px] ">
      <div className="flex flex-col gap-[30px] mt-10">
        <div className=" flex flex-col text-center gap-0">
          <h2 className="text-darkText text-center font-Poppins font-bold md:font-semibold text-[14px] md:text-[37px] uppercase ">
            Are you a host or a lessor?
          </h2>
          <p className=" text-black text-center font-Poppins font-normal md:font-light text-[10px] md:text-[23px]">
            Do you want to register or rent a vehicle?
          </p>
        </div>
        <div className="mx-auto ">
          <Link to="/host" onClick={() => dispatch(setRegisterAsHost(true))}>
            <button
              type="button"
              className="bg-white cursor-pointer text-darkText p-[10px] md:px-[81px] md:py-[15px] font-Poppins font-semibold text-[12px] md:text-[20px] rounded-md"
            >
              Register Your Vehicle Now!
            </button>
          </Link>
        </div>
      </div>
      <div className="mx-auto pt-10">
        <img src={tesla} alt="" />
      </div>
    </div>
  );
};

export default HostorLesee;
